import { render, staticRenderFns } from "./ColorSelector.vue?vue&type=template&id=7b53ebf0&scoped=true&"
import script from "./ColorSelector.vue?vue&type=script&lang=js&"
export * from "./ColorSelector.vue?vue&type=script&lang=js&"
import style0 from "./ColorSelector.vue?vue&type=style&index=0&id=7b53ebf0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b53ebf0",
  null
  
)

export default component.exports